var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"my-quotes-page py-4 mb-10"},[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"my-quotes-page__title",attrs:{"cols":"12"}},[_vm._v(" My Quotes ")]),_c('v-col',{attrs:{"cols":"12"}},[_c('my-quotes-table')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }